<template>
    <footer class="vue-footer-container">
        <div class="top-content">
            <div class="company-info">
                <div class="logo">
                    <img :src="URLS.icons.logo" alt="logo" />
                </div>
                <div class="social-media">
                    <div v-if="width >= 1200" class="social-wrapper">
                        <span class="follow-us">Follow Us:</span>
                        <div class="service-pages">
                            <a
                                v-for="item in footerSocialItems"
                                :key="item.text"
                                :href="item.target"
                                :target="item._blank ? '_blank' : ''"
                            >
                                <img :src="item.src" :alt="item.text" />
                            </a>
                        </div>
                    </div>
                    <div v-if="width < 768">
                        <div>
                            <div v-if="authed">
                                <button @click="logOut" class="signout-link">Log Off</button>
                            </div>
                            <div v-else class="mobile-auth">
                                <a
                                    v-for="item in footerActionItems"
                                    :key="item.text"
                                    :href="item.target"
                                    :target="item._blank ? '_blank' : ''"
                                    @click="handleActionClick(item.func)"
                                >
                                    {{ item.text }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu-links">
                <div class="footer-action-links" v-if="width >= 768 && width < 1200">
                    <div v-if="authed">
                        <button @click="logOut" class="signout-link">Log Off</button>
                    </div>
                    <div v-else class="register-login-links">
                        <a
                            v-for="item in footerActionItems"
                            :key="item.text"
                            :href="item.target"
                            :target="item._blank ? '_blank' : ''"
                            @click="handleActionClick(item.func)"
                        >
                            {{ item.text }}
                        </a>
                    </div>
                </div>
                <div class="footer-items-col1">
                    <a
                        v-for="item in footerCol1Items"
                        :key="item.text"
                        :href="item.target"
                        :target="item._blank ? '_blank' : ''"
                    >
                        {{ item.text }}
                    </a>
                </div>
                <div class="footer-items-col2">
                    <a
                        v-for="item in footerCol2Items"
                        :key="item.text"
                        :href="item.target"
                        :target="item._blank ? '_blank' : ''"
                    >
                        {{ item.text }}
                    </a>
                </div>
                <div class="footer-items-col3">
                    <a
                        v-for="item in footerCol3Items"
                        :key="item.text"
                        :href="item.target"
                        :target="item._blank ? '_blank' : ''"
                    >
                        {{ item.text }}
                    </a>
                </div>
                <div v-if="width < 768" class="footer-items-mobile">
                    <span>Follow Us:</span>
                    <div class="service-pages">
                        <a
                            v-for="item in footerSocialItems"
                            :key="item.text"
                            :href="item.target"
                            :target="item._blank ? '_blank' : ''"
                        >
                            <img :src="item.src" :alt="item.text" />
                        </a>
                    </div>
                </div>
                <div class="footer-action-links" v-if="width >= 1200">
                    <div v-if="authed">
                        <button @click="logOut" class="signout-link">Log Off</button>
                    </div>
                    <div v-else class="register-login-links">
                        <a
                            v-for="item in footerActionItems"
                            :key="item.text"
                            :href="item.target"
                            :target="item._blank ? '_blank' : ''"
                            @click="handleActionClick(item.func)"
                        >
                            {{ item.text }}
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="width >= 768 && width < 1200" class="footer-items-mobile">
                <span>Follow Us:</span>
                <div class="service-pages">
                    <a
                        v-for="item in footerSocialItems"
                        :key="item.text"
                        :href="item.target"
                        :target="item._blank ? '_blank' : ''"
                    >
                        <img :src="item.src" :alt="item.text" />
                    </a>
                </div>
            </div>
        </div>
        <div class="bottom-content">
            <div class="footer-divider"></div>
            <div class="service-pages copyright">
                <span>{{ `© ${fullYear} Hedlyner, Inc.` }}</span>
                <div class="links-container">
                    <a
                        v-for="item in footerBottomItems"
                        :key="item.text"
                        :href="item.target"
                        :target="item._blank ? '_blank' : ''"
                    >
                        {{ item.text }}
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import checkScreen from '@/mixins/check-screen'
    import { useAuth } from '@/composables/auth/useAuth'
    import { api } from '@/helpers/api'

    const URLS = {
        xhr: {
            checkAuth: '/api/check-authorization',
            user: '/api/profile/v1/settings/user',
            logout: '/logout'
        },
        icons: {
            logo: '/images/full-logo.svg'
        },
        redirect: {
            home: '/'
        }
    }

    export default {
        mixins: [checkScreen],
        name: 'Footer',
        setup() {
            const { MODES, mode, handleShowRegisterModal, handleShowLoginModal } = useAuth()

            return {
                MODES,
                mode,
                handleShowRegisterModal,
                handleShowLoginModal
            }
        },
        data: () => ({
            authed: false,
            csrf: document.head.querySelector('meta[name="csrf-token"]')['content'],
            fullYear: '',
            userInfo: {}
        }),
        methods: {
            async logOut() {
                await api({
                    method: 'post',
                    url: this.URLS.xhr.logout,
                    data: {
                        token: this.csrf
                    }
                })
                window.location.href = URLS.redirect.home
            },
            handleActionClick(func) {
                if (func === 'handleShowRegisterModal') {
                    this[func]({
                        registerMode:
                            this.mode === this.MODES.EventRegister ? 'event' : 'profile'
                    })
                } else {
                    this[func]()
                }
            },
            async checkAuth() {
                try {
                    const data = await api(
                        {
                            method: 'get',
                            url: this.URLS.xhr.checkAuth
                        },
                        { error: false }
                    )

                    this.authed = data.isAuthorized
                } catch {
                    this.authed = false
                }
            },
            async checkUser() {
                if (this.authed) {
                    const data = await api({
                        method: 'get',
                        url: this.URLS.xhr.user
                    })
                    this.userInfo = data.data[0]
                }
            }
        },
        async created() {
            let date = new Date()
            this.fullYear = date.getFullYear()
            await this.checkAuth()
            await this.checkUser()
        },
        computed: {
            footerItems: () => [
                {
                    category: 'social',
                    text: 'Instagram',
                    target: 'https://www.instagram.com/hedlyner.official',
                    src: '/images/icons/footer/instagram.svg',
                    _blank: true
                },
                {
                    category: 'social',
                    text: 'Facebook',
                    target: 'https://www.facebook.com/profile.php?id=61551715936993',
                    src: '/images/icons/footer/facebook.svg',
                    _blank: true
                },
                {
                    category: 'social',
                    text: 'LinkedIn',
                    target: 'https://www.linkedin.com/company/hedlyner/',
                    src: '/images/icons/footer/Linkedin.svg',
                    _blank: true
                },
                {
                    category: 'social',
                    text: 'TikTok',
                    target: 'https://www.tiktok.com/@hedlyner.official',
                    src: '/images/icons/footer/tiktok.svg',
                    _blank: true
                },
                {
                    category: 'col1',
                    text: 'For Artists',
                    target: '/for-artists'
                },
                {
                    category: 'col1',
                    text: 'For Bookers',
                    target: '/for-bookers'
                },
                {
                    category: 'col2',
                    text: 'Explore',
                    target: '/exploration'
                },
                {
                    category: 'col2',
                    text: 'Artist Pages',
                    target: '/search'
                },
                {
                    category: 'col2',
                    text: 'Venue Pages',
                    target: '/venue-search'
                },
                {
                    category: 'col2',
                    text: 'Opportunities',
                    target: '/opportunities'
                },
                /*{
                    category: 'col2',
                    text: 'Events',
                    target: '/events'
                },*/
                {
                    category: 'col3',
                    text: 'Contact Us',
                    target: '/contact-us'
                },
                {
                    category: 'col3',
                    text: 'About Us',
                    target: '/about-us'
                },
                {
                    category: 'col3',
                    text: 'FAQs',
                    target: '/faqs'
                },
                {
                    category: 'action',
                    text: 'Sign Up',
                    target: null,
                    func: 'handleShowRegisterModal'
                },
                {
                    category: 'action',
                    text: 'Log In',
                    target: null,
                    func: 'handleShowLoginModal'
                },
                {
                    category: 'bottom',
                    text: 'Terms',
                    target: '/terms-of-service',
                    _blank: true
                },
                {
                    category: 'bottom',
                    text: 'Privacy',
                    target: '/privacy-policy',
                    _blank: true
                },
                {
                    category: 'bottom',
                    text: 'Legal',
                    target: '/legal',
                    _blank: true
                }
            ],
            URLS: () => URLS,

            footerSocialItems: (self) =>
                self.footerItems.filter((i) => i.category === 'social'),
            footerCol1Items: (self) => {
                let arr = self.footerItems.filter((i) => i.category === 'col1')
                let filteredArr = arr.filter((a) => a.text !== 'Opportunities')
                return self.userInfo.isVenue ? filteredArr : arr
            },
            footerCol2Items: (self) => self.footerItems.filter((i) => i.category === 'col2'),
            footerCol3Items: (self) => self.footerItems.filter((i) => i.category === 'col3'),
            footerActionItems: (self) =>
                self.footerItems.filter((i) => i.category === 'action'),
            footerBottomItems: (self) =>
                self.footerItems.filter((i) => i.category === 'bottom')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';

    .vue-footer-container {
        @include flex-col;
        background: $dark;
        width: 100%;
        min-height: 285px;
        padding: 30px 90px 25px 90px;
        position: relative;
        z-index: 119;
        gap: 88px;

        @media screen and (max-width: $desktop) {
            padding: 48px 0;
            gap: 48px;
        }

        .top-content {
            @include flex-justify-space-between;

            .company-info {
                @include flex-col;
                gap: 16px;

                .logo {
                    @include flex-row;

                    img {
                        max-width: 300px;
                        min-height: 43px;
                    }
                }

                .social-media {
                    display: flex;
                    gap: 25px;
                    justify-content: flex-start;
                    align-items: flex-start;
                    @media screen and (max-width: $desktop) {
                        align-items: self-start;
                        flex-direction: column;
                        margin-top: 48px;
                    }
                    .social-wrapper {
                        display: flex;
                        gap: 15px;
                        align-items: center;
                        .follow-us {
                            color: $lime;
                        }
                    }
                    p {
                        color: $lime;
                        line-height: 133%; /* 23.94px */
                        @include base-font-18;
                        margin-bottom: 0;
                    }

                    .mobile-auth {
                        @include flex-col;
                        gap: 15px;
                        a {
                            color: $lime;
                        }
                    }
                }

                @media screen and (min-width: $mobile) and (max-width: $desktop) {
                    flex-direction: revert;
                }

                @media screen and (max-width: $desktop) {
                    align-items: flex-start;
                }
            }
            .menu-links {
                @include flex-justify-space-between;
                max-width: 620px;
                width: 100%;

                @media screen and (max-width: $desktop) {
                    flex-direction: column;
                    margin-left: 0 !important;
                    gap: 48px;
                }

                @media screen and (min-width: $mobile) and (max-width: $desktop) {
                    flex-direction: revert;
                }

                .footer-items-col1,
                .footer-action-links {
                    @include flex-col;
                    align-items: flex-start;

                    button {
                        color: $lime;
                        @include without-border-background;
                        line-height: 133%; /* 23.94px */
                        @include base-font-18;
                    }

                    a {
                        margin: 12px 0px;
                    }
                }

                .footer-items-col2,
                .footer-items-col3 {
                    @include flex-col;
                    align-items: flex-start;

                    a {
                        margin: 12px 0px;
                    }
                }

                .footer-action-links {
                    a {
                        cursor: pointer;
                    }
                }

                .register-login-links {
                    @include flex-col;

                    a {
                        color: $lime;
                    }

                    p {
                        color: $lime;
                        line-height: 133%; /* 23.94px */
                        @include base-font-18;
                    }
                }
            }

            .footer-items-mobile {
                @include flex-col;
                gap: 24px;
                align-items: flex-start;
                span {
                    color: $lime;
                    line-height: 133%; /* 23.94px */
                    @include base-font-16;
                }
            }

            .signout-link {
                @include without-border-background;
                color: $lime;
                line-height: 133%; /* 23.94px */
                @include base-font-18;
                margin: 12px 0;
            }

            @media screen and (max-width: $desktop) {
                flex-wrap: wrap;
                gap: 48px;
                margin: 0px 24px;

                .bottom-content {
                    flex-direction: column-reverse;
                }
            }

            @media screen and (min-width: $mobile) and (max-width: $desktop) {
                margin: 0 60px;
            }
        }

        .service-pages {
            display: flex;
            gap: 16px;
            align-items: baseline;

            &.copyright {
                @media screen and (max-width: $desktop) {
                    flex-direction: column-reverse;
                    gap: 24px;
                }
                .links-container a {
                    margin-right: 24px;
                }
            }
        }
        span {
            color: #8b8b8b;
            line-height: 133%; /* 23.94px */
            @include base-font-18;
            text-wrap: nowrap;
        }
        a {
            color: #8b8b8b;
            line-height: 133%; /* 23.94px */
            @include base-font-18;
            text-wrap: nowrap;
            &:link {
                text-decoration: inherit;
            }
            &:visited {
                text-decoration: inherit;
            }
            &:hover {
                color: $lime;
            }
        }
        .bottom-content {
            display: flex;
            gap: 24px;
            margin-bottom: 24px;
            flex-wrap: wrap;
            .footer-divider {
                height: 1px;
                background: $lighter-dark;
                width: 100%;
            }

            @media screen and (max-width: $desktop) {
                margin: 0 24px;
            }

            @media screen and (min-width: $mobile) and (max-width: $desktop) {
                margin: 0 60px;
            }
        }
    }
</style>
